<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="@/assets/back.png" alt="返回" />
          <span>返回</span>
        </div>
      </div>
      <Title class="mt20">基础信息</Title>
      <el-descriptions class="margin-top" title="" :column="3">
        <el-descriptions-item label="订单编号">{{rowItem.orderNumber}}</el-descriptions-item>
        <el-descriptions-item label="充值类型">{{rowItem.rechargeType}}</el-descriptions-item>
        <el-descriptions-item label="用户信息">{{rowItem.userName}} {{rowItem.userPho}}</el-descriptions-item>
        <el-descriptions-item label="身份">
          <span v-if="rowItem.orderType === 1">{{ rowItem.businessType==1?'体验班':rowItem.businessType==2?'研修班':'' }}</span>
          <span v-else>{{ rowItem.clevel==6?'研修班':rowItem.clevel==7?'体验班':'普通用户' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="充值账户">{{ rowItem.mainId==0?'主账号':'子账号' }}</el-descriptions-item>
        <el-descriptions-item label="入账账户">{{ rowItem.accountType==1?'主账户':'子账户' }}</el-descriptions-item>
        <el-descriptions-item label="充值方式">{{dataSourceTxt[rowItem.dataSource]}}</el-descriptions-item>
        <el-descriptions-item label="支付方式">{{ rowItem.payType==1?'支付宝':rowItem.payType==2?'微信':'-' }}</el-descriptions-item>
        <el-descriptions-item label="充值金额">{{ rowItem.orderAmount }}</el-descriptions-item>
        <el-descriptions-item label="支付单">{{rowItem.payOrderNum}}</el-descriptions-item>
        <el-descriptions-item label="赠送类型">{{ rowItem.giveType==2?'商品：'+rowItem.goodsName:rowItem.giveType==1?'零售价：'+rowItem.xiaoduMoney:'-' }}</el-descriptions-item>
        <el-descriptions-item label="充值时间">{{rowItem.createdTime}}</el-descriptions-item>
        <el-descriptions-item label="备注">{{rowItem.orderNote}}</el-descriptions-item>
        <el-descriptions-item label="通商云单号">{{rowItem.threeOrderNo}}</el-descriptions-item>
        <el-descriptions-item label="城市公司">{{rowItem.nameCity}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="付款信息" :column="5" v-if="info.list && info.list.length">
        <template v-for="(item,index) in info.list">
          <el-descriptions-item :key="`payImg-${index}`" label="付款凭证">
            <el-image style="width: 50px;height:50px;" fit="cover" :src="item.payImg" :preview-src-list="[item.payImg]"></el-image>
          </el-descriptions-item>
          <el-descriptions-item :key="`payBank-${index}`" label="收款银行">{{item.payBank}}</el-descriptions-item>
          <el-descriptions-item :key="`payMethod-${index}`" label="付款方式">{{info.payMethod === 1 ? '扫码支付' : info.payMethod === 2 ? '银行转账' : '-'}}</el-descriptions-item>
          <el-descriptions-item :key="`payNum-${index}`" label="支付单号">{{item.payNum}}</el-descriptions-item>
          <el-descriptions-item :key="`payMoney-${index}`" label="付款金额">{{item.payMoney}}</el-descriptions-item>
          <el-descriptions-item :key="`payTime-${index}`" label="付款日期">{{item.payTime}}
            <span style="color: #1596cd;cursor: pointer;margin-left: 5px;" @click="handleEdit(item)">修改</span>
          </el-descriptions-item>
        </template>
      </el-descriptions>
      <Title class="mt20">发展业务线</Title>
      <div>业务线：{{rowItem.serviceLine}}</div>
    </el-card>
    <Edit ref="edit" @created="handleShow" mode="recharge"></Edit>
  </div>
</template>

<script>
import rechargeRecordApi from '@/api/recharge/rechargeRecord'
import Edit from '../../finance/proofAudit/edit.vue'
export default {
  props: ['rowItem', 'technicalState'],
  components: { Edit },
  data() {
    return {
      list: [],
      info: {},
      dataSourceTxt: ['', '自己升级', '老师升级', '后台升级', 'App充值', '线下充值']
    }
  },
  created() {
    this.handleShow()
  },
  methods: {
    handleShow() {
      rechargeRecordApi.fetchById(this.rowItem.id).then(res => {
        this.info = res.data
      })
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    },
    handleEdit(item) {
      this.$refs.edit.handleCreate(item)
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
